/* eslint-disable max-len */
import { RootState } from 'interfaces';
import { createSelector } from '@reduxjs/toolkit';
import { initialState } from './slice';

const selectDomain = (state: RootState) => state['feature/users'] || initialState;

export const selectUsers = createSelector([selectDomain], (UsersState) => UsersState.users);
export const selectUsersLoader = createSelector([selectDomain], (UsersState) => UsersState.loading);
export const selectUsersTotal = createSelector([selectDomain], (UsersState) => UsersState.total);
export const selectProfile = createSelector([selectDomain], (UsersState) => UsersState.profile);
